module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v("HidroAdmin")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Trofeul Hidrotehnicii 2019")]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": _vm.homepage
    }
  }, [_vm._v("Demo Live")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d1df42d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 154
// module chunks = 14